import cx from 'classnames'
import { type ReactNode } from 'react'

interface FooterBlockProps {
  title?: string
  children?: ReactNode
  className?: string
}

const FooterBlock = ({ title, children, className }: FooterBlockProps) => {
  return (
    <div
      className={cx(
        'flex flex-col gap-y-5 border-t-[1px] border-pageText lg:pb-[70px]',
        'px-[var(--container-padding)] xs:px-[calc(var(--container-padding)+var(--page-padding))] py-6',
        className,
      )}
    >
      {!!title && <h4 className="is-h5 font-medium">{title}</h4>}
      {children}
    </div>
  )
}

export default FooterBlock
